var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 38 34.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_738",
    "data-name": "\\u7EC4 738",
    transform: "translate(-1694 -74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_737",
    "data-name": "\\u7EC4 737"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_607",
    "data-name": "\\u77E9\\u5F62 607",
    width: 38,
    height: 9.148,
    rx: 3.889,
    transform: "translate(1694 74)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_608",
    "data-name": "\\u77E9\\u5F62 608",
    width: 38,
    height: 9.148,
    rx: 3.889,
    transform: "translate(1694 86.667)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_609",
    "data-name": "\\u77E9\\u5F62 609",
    width: 38,
    height: 9.148,
    rx: 3.889,
    transform: "translate(1694 99.333)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.60a1aff03e98677da9e7176c158e40b6.svg";
export { ForwardRef as ReactComponent };